import { cx } from "../control/ui/primitives";

/**
 * The "NEW!" tag every freshly-launched surface wears until its own sunset — extracted
 * 2026-09-09 (Daily Quests was the second caller; the first, Infinity Walls' picker
 * row, is what this was born as — see its own INFINITY_NEW_UNTIL for that sunset).
 *
 * Two placements, one component, so a badge never drifts into two spellings:
 * - `corner` rides a tile's top-right like a tag — the accent on black, ringed in the
 *   page's own ink so it reads as pinned ON the tile rather than floating past its edge.
 *   For a tile whose ancestor is `position: relative`.
 * - `inline` sits beside a label in the normal flow — a section header, not a tile.
 *
 * A badge with no sunset is a badge nobody notices after the first week. There is no
 * shared expiry here on purpose: each caller owns its own `Date.UTC(...)` constant, so
 * extending one surface's badge is never a chance to silently extend another's.
 */
export function NewBadge({ variant = "corner" }: { variant?: "corner" | "inline" }) {
  return (
    <span
      aria-hidden
      className={cx(
        "rounded-full bg-[var(--color-accent)] px-1.5 py-0.5 text-[9px] font-extrabold uppercase leading-none tracking-wide text-black",
        variant === "corner"
          ? "absolute -top-1.5 right-2 shadow-[0_0_0_2px_var(--color-ink)]"
          : "ml-1.5 align-middle",
      )}
    >
      New!
    </span>
  );
}
